import DOMPurify from 'dompurify';

export class HtmlUtils {
    private static readonly config = {
        ALLOWED_TAGS: ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'strong', 'i', 'b', 'ul', 'ol', 'li', 'a', 'br'],
        ALLOWED_ATTR: ['href', 'target', 'class', 'id', 'style', 'title', 'role', 'aria-label', 'src', 'alt'],
        FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'input', 'textarea', 'button', 'select', 'option'],
        FORBID_ATTR: [
            'onerror', 'onload', 'onclick', 'onmouseover', 'onmouseout', 'onfocus', 'onblur', 'onchange', 'oninput', 
            'onsubmit', 'onreset', 'onselect', 'onkeydown', 'onkeyup', 'onkeypress'
        ],
    };

    public static sanitize(html: string): string {
        return DOMPurify.sanitize(html, this.config);
    }

    public static escapeHtml(unsafe: string): string {
        return unsafe
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }
}